/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import Immutable from 'seamless-immutable';
import { generateForm } from '../../../../../utils/reducerHalpers/formFields';
import { createReducerDotPathName } from './naming';
import { getItemFromRefList } from '../../../../main/reducers/static/states/referenceLists/reducer';

const getState = (state, reducerName) =>
  Immutable.asMutable(_.get(state, createReducerDotPathName(reducerName)), {
    deep: true
  });

export const selectState = (state, reducerName) => getState(state, reducerName);

export const selectSendRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestStates.send');

export const selectRecoveryRequestState = (state, parentName) =>
  _.get(getState(state, parentName), 'requestStates.recovery');

export const selectFormBody = (state, reducerName) =>
  generateForm(_.get(getState(state, reducerName), 'fields'));

export const selectAllErrors = (state, reducerName) =>
  _.get(getState(state, reducerName), 'errors');

export const selectLinkErrorByKey = (state, reducerName, key) =>
  _.get(getState(state, reducerName), `errors.links_${key}`);

export const selectQuizAskErrorByKey = (state, reducerName, keyAsk) =>
  _.get(getState(state, reducerName), `errors.quiz_${keyAsk}`);

export const selectQuizAnswerErrorByKeys = (
  state,
  reducerName,
  keyAsk,
  keyAnswer
) => _.get(getState(state, reducerName), `errors.quiz_${keyAsk}_${keyAnswer}`);

export const selectResultObject = (state, reducerName) =>
  _.get(getState(state, reducerName), 'resultObject');

// Fields
export const selectFieldTitle = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.title');
export const selectFieldTypeId = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.type_id');
export const selectFieldLocaleCode = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.locale_code');
export const selectFieldCostExecution = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.cost_execution');
export const selectFieldMaxExecutions = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.max_executions');
export const selectFieldDesc = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.desc');
export const selectFieldCheckType = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.check_type');
export const selectFieldLinks = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.links');
export const selectFieldRandomLink = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.random_link');
export const selectFieldAdultContent = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.adult_content');
export const selectFieldSoftwareInstall = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.software_install');
export const selectFieldTimeChecking = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.time_checking');
export const selectFieldTimePerform = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.time_perform');
export const selectFieldExecutorExecutionInterval = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.executor_execution_interval');
export const selectFieldExecutorExecutionIntervalCheck = (state, reducerName) =>
  _.get(
    getState(state, reducerName),
    'fields.executor_execution_interval_check'
  );
export const selectFieldCheckDesc = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.check_desc');
export const selectFieldRequireLinkInReport = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.require_link_in_report');
export const selectFieldRequireScreenshotInReport = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.require_screenshot_in_report');
export const selectFieldPExecutorEmailConfirm = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.p_executor_email_confirm');
export const selectFieldPHideForBlackList = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.p_hide_for_black_list');
export const selectFieldPMinRating = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.p_executor_min_rating');

export const selectFieldQuiz = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.quiz');
export const selectFieldQuizAsk = (state, reducerName, key) => {
  const values = _.get(getState(state, reducerName), 'fields.quiz.value');
  if (values[key]) {
    return values[key].ask;
  }
  return null;
};
export const selectFieldQuizAnswers = (state, reducerName, key) => {
  const values = _.get(getState(state, reducerName), 'fields.quiz.value');
  if (values[key]) {
    return values[key].answer;
  }
  return null;
};

export const selectFieldTimeTarget = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.time_target');

export const selectFieldGeoTarget = (state, reducerName) =>
  _.get(getState(state, reducerName), 'fields.geo_target');

export const selectDetailsCosts = (state, reducerName) => {
  const costExecution = selectFieldCostExecution(state, reducerName).value;
  const maxExecutions = selectFieldMaxExecutions(state, reducerName).value;
  const taskExecCommissionPerc = getItemFromRefList(
    state,
    'taskExecCommissionPerc'
  );
  const result = {
    totalSum: (costExecution * maxExecutions).toFixed(2).toString(),
    execCostForExecutor: parseFloat(
      costExecution - (costExecution * taskExecCommissionPerc) / 100
    )
      .toFixed(2)
      .toString()
  };
  return result;
};



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors.js